import React, { FC } from "react";
import styles from "./TopBar.module.scss";
import { Link } from "react-scroll";
import Logo from "./../../../Static/Images/QUEROVET - LOGO AZUL.png";
import { isMobile } from "react-device-detect";

export const MenuItems: { to: string; label: string }[] = [
  {
    label: "Ínicio",
    to: "principal",
  },
  {
    label: "Planos",
    to: "planos",
  },
  {
    label: "O que é",
    to: "about",
  },
  {
    label: "Time Querovet",
    to: "time",
  },
  {
    label: "Depoimentos",
    to: "depoimentos",
  },
  {
    label: "Perguntas Frequentes",
    to: "perguntasfrequentes",
  },
];

export const TopBar: FC = () => {
  return (
    <div className={`${styles["TopBar"]} ${isMobile ? styles["mobile"] : ""}`}>
      {!isMobile && (
        <img alt="Logo Quero Vet" src={Logo} className={styles["Logo"]} />
      )}
      {MenuItems.map((item, idx) => {
        return (
          <Link
            activeClass="active"
            to={item.to}
            key={`item-menu-${idx}`}
            spy={true}
            smooth={true}
            duration={500}
          >
            <p className={styles["title"]}>{item.label}</p>
          </Link>
        );
      })}
    </div>
  );
};
